import React, { PureComponent } from "react";

import "./panel.css";

class Panel extends PureComponent {
  classNames() {
    const classes = ["panel"];
    classes.push("panel--" + this.props.type);
    return classes.join(" ");
  }

  render() {
    return <div className={this.classNames()}>{this.props.content}</div>;
  }
}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/support/panel/index.jsx